import React,{useEffect} from "react";

import "./Graduatesinfo.css";

import { Timeline } from "../../components";
import { Backtotop,Underline } from "../../widgets";

import { graduates_cals } from "../../constants/academic_calendar";

const Graduatesinfo = () => {
  useEffect(() => {
    document.title = 'ACCET-Graduates Information';
  }, []);
  return (
    <div>
      <Backtotop />

      <div className="graduates_container">
        {/* <div className="academic_heading">Academic Calendar</div> */}
        <Underline heading="List of Eligible Graduates"/>
        <div className="graduates_cals_container">
          <div className="graduates_reports">
            {graduates_cals.map((item) => (
              <Timeline
                key={item.id}
                head={item.head}
                house={item.house}
                pdf={item.pdf}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Graduatesinfo;
